'use client';

import { ElementComponents } from '@/components/sections/builder/builder-element';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import BuilderPreviewPage from '@/components/sections/builder/preview-page';
import { ElementType, ThemeType } from '@/stores/builder';
import { useStoreSetting } from '@/app/(store)/s/[domain]/store-context';

type HomepageProps = {
  header: ElementType[];
  body: ElementType[];
  footer: ElementType[];
  elements: ElementType[];
  host: string;
  theme: ThemeType;
  navigation?: any;
};

export default function HomePage({
  header,
  body,
  footer,
  elements,
  host,
  theme,
  navigation,
}: HomepageProps) {
  const query = useSearchParams();
  const { storeSetting } = useStoreSetting();
  const isPreview = query.get('isPreview') || false;
  const headerElement = React.useMemo(() => header.find((e) => e.type === 'header'), [header]);
  const headerData = headerElement?.data as HeaderElementDataType;

  React.useEffect(() => {
    if (!isPreview) return;
    window.parent?.postMessage({ type: 'iframe_loaded' }, '*');
  }, [isPreview]);

  if (isPreview) return <BuilderPreviewPage groupBody='body,body_home' />;

  return (
    <>
      <link rel='icon' href={headerData?.faviconUrl} type='image/x-icon' />

      <header id='wrapper-header'>
        {header?.map((element: ElementType) => {
          const Element = ElementComponents[element.type]?.Element;
          if (Element) {
            return (
              <Element
                element={element}
                key={element.id}
                host={host}
                theme={theme}
                navigation={navigation?.data}
              />
            );
          }
          return null;
        })}
      </header>
      <div className='theme_layout_space_section flex-grow'>
        {body?.map((element) => {
          const Element = ElementComponents[element.type]?.Element;
          if (Element) {
            return (
              <Element
                element={element}
                key={element.id}
                host={host}
                theme={theme}
                elements={elements}
                storeSetting={storeSetting}
              />
            );
          }
          return null;
        })}
      </div>
      {footer?.map((element) => {
        const Element = ElementComponents[element.type]?.Element;
        if (Element) {
          return <Element element={element} key={element.id} navigation={navigation?.data} />;
        }
        return null;
      })}
    </>
  );
}
